import { nomParDefautDossier, type SchemaDeGarde } from '@repere/core';
import type { EnfantDuDossier } from './types';

/**
 * Le nom d'un dossier : celui que le parent lui a donné, ou celui qu'il porte par défaut.
 *
 * Un seul endroit décide, parce que trois écrans l'affichent — l'accueil, l'en-tête du
 * dossier, le champ de renommage — et que trois formulations donneraient l'impression de
 * trois choses différentes.
 */
export function nomDuDossier(
  label: string | null,
  enfants: EnfantDuDossier[],
  schema: SchemaDeGarde | null,
): string {
  const propre = label?.trim();
  if (propre) return propre;
  return nomParDefautDossier(
    enfants.map((enfant) => enfant.firstName),
    schema,
  );
}
